import { Col, Row } from "antd";
import React from "react";

export default function Overview() {
  return (
    <Row gutter={[0, 24]}>
      <Col xs={24}>
        <h1>Overview</h1>
      </Col>
      <Col className="w-font-md fw-600 color-text-secondary" xs={24}>
        <p>
          vIRL Marketplace Widget is the fastest and easiest community-driven
          tools to fully unlock the potential of your digital assets. Which just
          a few simple steps to set up and embed it to your website, a fully
          functional NFT marketplace is ready to use.There’s no better time than
          now to onboard the NFT space, and build a brand that is ready for
          immense growth ahead.
        </p>
      </Col>
    </Row>
  );
}
